import styled from "styled-components";
//#3d85c6
export const Styles = styled.div`
  width: 100%;
  .container_show {
    text-align: center;
    cursor: pointer;
    .container_show_item {
      display: inline-flex;
      align-items: center;
      gap: 10px;
    }
  }
`;

export const StyleContainerOption = styled.div`
  background: #fff;
  color: #000;
  text-align: left;
  .option_item {
    display: flex;
    cursor: pointer;
    gap: 10px;
    &.checked {
      font-weight: 700;
    }
    &.unchecked {
      opacity: 0.7;
    }
    &:hover {
      opacity: 1;
    }
    .icon_checked {
      opacity: 0;
    }
    &.checked .icon_checked {
      opacity: 1;
    }
  }
`;
